<script>
    import { saveRole, deleteRole } from '@/api/user.js';

    export default {
        computed: {
            isSaveButton() {return this.$store.getters.IS_SAVE_ROLE_EDIT},
            permission() {return this.$store.getters.CONST_PERMISSIONS},
            editRoleData() {return this.$store.getters.ROLE_EDIT_DATA},
        },
        methods: {
            async close() {
                this.$store.commit('IS_SHOW_ROLE_EDIT', false);
            },
            async clear() {
                this.permission.forEach((permissionValue, permissionIndex) => {
                    this.$store.commit('ROLE_EDIT_UPDATE', {
                        fieldName: permissionValue.id,
                        fieldValue: false
                    });
                });
            },
            async save() {
                const response = await saveRole(this.editRoleData);
                if (response === true) {
                    this.$store.commit('ROLES_UPDATE', {
                        id: this.editRoleData.id,
                        payload: this.editRoleData,
                    });
                    await this.close();
                }
            },
            async deleteObj() {
                const response = await deleteRole(this.editRoleData.id);
                if (response === true) {
                    this.$store.commit('ROLE_SPLIT', 
                        this.editRoleData.id
                    );
                    await this.close();
                }
            }
        }
    }
</script>


<template>
    <div>
        <button
            :disabled="isSaveButton === false"
            class="button_blue_100"
            @click="save"
        >Save</button>
        <button
            class="button_blue_100 ml_10"
            @click="clear"
        >Clear Permission</button>
        <button
            class="button_blue_100 ml_10 button_red"
            @click="deleteObj"
        >Delete</button>
        <button
            class="button_blue_100 close_button mr_10"
            @click="close"
        >Close</button>
    </div>
</template>